"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyParams = exports.DOCUMENT_STATUSES = void 0;
var emptyParams = exports.emptyParams = function emptyParams() {
  return {};
};
var DOCUMENT_STATUSES = exports.DOCUMENT_STATUSES = ['DRAFT', 'ACTIVE', 'INACTIVE', 'DELETED'];